import React, { useRef, useState } from "react";
import ndovuHr from "../../../assets/img/ndovuPayShield.png";
import svg103 from "../../../assets/svg/svg103.svg";
import toast from "react-hot-toast";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import svg85 from "../../../assets/svg/svg85.svg";
import { jwtDecode } from "jwt-decode";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { save, setTokenSeeker } from "../../../features/auth/authSlice";

function LoginSeeker() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving, user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      const res = await dispatch(
        save({
          accessToken: response.access_token,
          url: "auth/google",
        })
      );
      if (res?.payload?.success) {
        toast.success(res.payload?.messages?.message);
        await dispatch(setTokenSeeker(res?.payload?.token));
        await navigate("/recruitment/career-list");
      } else {
        toast.error(res.payload?.messages?.message ?? "Invalid credentials");
      }
    },
    onError: () => console.log("Login Failed"),
  });

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        ...data,
        url: "auth/login",
      })
    );
    if (res?.payload?.success) {
      toast.success(res.payload?.messages?.message);
      await dispatch(setTokenSeeker(res?.payload?.token));
      await navigate("/recruitment/career-list");
    } else {
      toast.error(res.payload?.messages?.message ?? "Invalid credentials");
    }
  };

  return (
    <div className=" h-screen  w-full overflow-y-scroll">
      <div className="flex items-center justify-center text-center  h-full">
        <div
          className="lg:w-[43.75rem] w-full border border-[rgba(243,183,64,0.5)] cardSeeker rounded-[1.25rem] bg-white
              lg:px-[5rem] px-3 py-[2.5rem]"
        >
          <div className="flex lg:gap-[2rem] gap-[1rem]">
            <img
              loading="lazy"
              decoding="async"
              src={ndovuHr}
              alt="logo"
              className="w-[5.5rem]  h-[5rem] object-contain"
            />
            <div className="flex flex-col items-start">
              <span className="text-[#050505] text-[1.5rem] font-[600] font-dmSans">
                Welcome to Ndovu HR
              </span>
              <span className="text-[#828282] text-[1.125rem] font-[500] font-dmSans">
                Sign in to proceed
              </span>
            </div>
          </div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            style={{
              maxWidth: "100%",
            }}
            className="w-full mt-[2.5rem]"
            form={form}
          >
            <Form.Item
              name="email"
              label="Enter Email"
              rules={[
                {
                  required: true,
                  message: "Add email address",
                },
                {
                  type: "email",
                  message: "Enter a valid email",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                type="password"
              />
            </Form.Item>

            <div className="flex items-center justify-between">
              <Link className="text-[#828282] text-[.875rem] font-[400] cursor-pointer">
                {" "}
                Forgot Password
              </Link>
              <span
                className="text-[#1A1A1A] text-[.875rem] font-[600] cursor-pointer"
                onClick={() => navigate("/recruitment/register-seeker")}
              >
                Create Account
              </span>
            </div>

            <button
              disabled={saving}
              className={`cstm-btn mt-[2.5rem]`}
              type="submit"
            >
              {saving ? <Spin /> : "Sign In"}
            </button>

            <button
              disabled={saving}
              className={`cstm-btn-2 mt-[1rem] gap-[1rem]`}
              type="button"
              onClick={() => login()}
            >
              {saving ? (
                <Spin className="sms-spin" />
              ) : (
                <>
                  <img src={svg103} alt="svg103" />
                  Continue with google
                </>
              )}
            </button>

            <div
              className="mt-[2.5rem] flex items-center text-[#000] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
              onClick={() => navigate("/recruitment/career-list")}
            >
              <img src={svg85} alt="svg85" /> Back
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default LoginSeeker;
